var map = {
	"./demos/basic/index.ts": 14322,
	"./demos/button/index.ts": 77417,
	"./demos/content/index.ts": 896,
	"./demos/text/index.ts": 65146,
	"./demos/type/index.ts": 83821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84678;